var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.207 11.2084C11.207 11.8987 10.6474 12.4584 9.95703 12.4584H6.20703C5.51669 12.4584 4.95703 11.8987 4.95703 11.2084V6.20837C4.95703 5.51802 5.51669 4.95837 6.20703 4.95837H9.95703C10.6474 4.95837 11.207 5.51802 11.207 6.20837V11.2084Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.707 18.4584C19.707 19.1487 19.1474 19.7084 18.457 19.7084H14.707C14.0167 19.7084 13.457 19.1487 13.457 18.4584V13.4584C13.457 12.768 14.0167 12.2084 14.707 12.2084H18.457C19.1474 12.2084 19.707 12.768 19.707 13.4584V18.4584Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.207 18.4584C11.207 19.1487 10.6474 19.7084 9.95703 19.7084H6.20703C5.51669 19.7084 4.95703 19.1487 4.95703 18.4584V15.9584C4.95703 15.268 5.51669 14.7084 6.20703 14.7084H9.95703C10.6474 14.7084 11.207 15.268 11.207 15.9584V18.4584Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.707 8.70837C19.707 9.39871 19.1474 9.95836 18.457 9.95836H14.707C14.0167 9.95836 13.457 9.39871 13.457 8.70837V6.20837C13.457 5.51802 14.0167 4.95837 14.707 4.95837H18.457C19.1474 4.95837 19.707 5.51802 19.707 6.20837V8.70837Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e7fc181152aee5736abf4b3f71b39e51.svg";
export { ForwardRef as ReactComponent };